// Configuração centralizada do nServer Tools
// Altere estas URLs conforme necessário

const config = {
  // URL da API (backend)
  API_URL: 'https://nservers-api.gabrielp.com.br',
  
  // URL do site (frontend)
  SITE_URL: 'https://tools.nservers.io',
  
  // Configurações de desenvolvimento
  DEV_API_URL: 'http://localhost:3070',
  DEV_SITE_URL: 'http://localhost:3000',
  
  // Determina se está em desenvolvimento ou produção
  isDevelopment: import.meta.env.DEV,
  
  // Retorna a URL da API baseada no ambiente
  getApiUrl() {
    return this.isDevelopment ? this.DEV_API_URL : this.API_URL;
  },
  
  // Retorna a URL do site baseada no ambiente
  getSiteUrl() {
    return this.isDevelopment ? this.DEV_SITE_URL : this.SITE_URL;
  }
};

export default config; 